if (!customElements.get('oa-product-offers')) {
  customElements.define('oa-product-offers', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      this.form = document.getElementById(this.dataset.form);
      this.variants = JSON.parse(this.querySelector('[data-offer-variants]').textContent);
      const currency = this.dataset.currency || 'PKR';
      const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', {minimumFractionDigits: 0, maximumFractionDigits: 2});
      this.money = {format: value => `${currency === 'PKR' ? 'Rs.' : currency} ${formatter.format(value)}`};
      this.addEventListener('change', () => this.update(), options);
      const nativeBuyNow = this.form?.querySelector('[data-oa-buy-now]');
      if (nativeBuyNow && !this.form.querySelector('[data-oa-offer-buy-now]')) {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'button button--full-width button--primary';
        button.dataset.oaOfferBuyNow = '';
        button.textContent = 'Buy now';
        button.hidden = true;
        button.style.display = 'none';
        nativeBuyNow.before(button);
      }
      this.form?.querySelector('[data-oa-offer-buy-now]')?.addEventListener('click', () => this.addSelection(true), options);
      this.form?.addEventListener('submit', event => {
        if (this.dataset.preview === 'true' && (this.quantity() > 1 || this.querySelector('.oa-offers__soaps input:checked'))) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.querySelector('.oa-offers__status').textContent = this.dataset.blocked;
          this.scrollIntoView({block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
          return;
        }
        if (this.querySelector('.oa-offers__soaps input:checked')) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.addSelection(false);
        }
      }, {...options, capture: true});
      this.productInfo = this.closest('product-info') || this.closest('.product__info-container');
      this.quantityInput = document.querySelector(`input[name="quantity"][form="${CSS.escape(this.dataset.form)}"]`) || this.form?.querySelector('[name="quantity"]');
      this.quantityInput?.addEventListener('change', () => {
        const value = Number(this.quantityInput.value);
        this.querySelectorAll('.oa-offers__tiers input').forEach(input => {input.checked = Number(input.value) === value;});
        this.update(false);
      }, options);
      this.observer = new MutationObserver(() => this.update(false));
      const idInput = this.form?.querySelector('[name="id"]');
      if (idInput) this.observer.observe(idInput, {attributes: true, attributeFilter: ['value', 'disabled']});
      this.update(false);
    }
    disconnectedCallback() {this.controller?.abort(); this.observer?.disconnect();}
    async addSelection(checkout) {
      if (this.pending || this.dataset.preview === 'true') return;
      const status = this.querySelector('.oa-offers__status');
      const buttons = [...this.form.querySelectorAll('button[type="submit"], [data-oa-offer-buy-now]')];
      const disabled = buttons.map(button => button.disabled);
      this.pending = true;
      buttons.forEach(button => button.disabled = true);
      status.textContent = 'Adding your selection…';
      let added = false;
      try {
        const data = new FormData(this.form);
        const properties = {};
        for (const [name, value] of data) {
          const match = name.match(/^properties\[(.+)\]$/);
          if (match && typeof value === 'string') properties[match[1]] = value;
        }
        const main = {id: Number(data.get('id')), quantity: this.quantity(), properties};
        if (data.get('selling_plan')) main.selling_plan = data.get('selling_plan');
        const items = [main, ...[...this.querySelectorAll('.oa-offers__soaps input:checked')].map(input => ({id: Number(input.value), quantity: 1}))];
        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        const body = {items};
        if (cart && !checkout) {
          body.sections = cart.getSectionsToRender().map(section => section.id);
          body.sections_url = location.pathname;
          cart.setActiveElement(document.activeElement);
        }
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json','X-Requested-With':'XMLHttpRequest'}, body:JSON.stringify(body)});
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || result.message || 'Unable to add this selection. Please check availability.');
        added = true;
        if (checkout) {location.assign(`${window.Shopify.routes.root}checkout`);return;}
        if (!cart || !body.sections.every(id => result.sections?.[id])) {location.assign(window.routes.cart_url);return;}
        cart.classList.remove('is-empty');
        cart.renderContents({...result, id:result.items?.[0]?.id || main.id});
        status.textContent = 'Your selection was added to the cart.';
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, {source:'oa-product-offers', productVariantId:main.id, cartData:result});
      } catch (error) {
        if (added) location.assign(window.routes.cart_url);
        else status.textContent = error.message || 'Could not confirm the cart update. Check your cart before trying again.';
      } finally {
        this.pending = false;
        buttons.forEach((button, index) => button.disabled = disabled[index]);
      }
    }
    quantity() {return Number(this.querySelector('.oa-offers__tiers input:checked')?.value || this.quantityInput?.value || 1);}
    update(sync = true) {
      const id = this.form?.querySelector('[name="id"]')?.value;
      const variant = this.variants.find(item => String(item.id) === String(id)) || this.variants[0];
      if (!variant) return;
      const quantity = this.quantity();
      if (sync && this.quantityInput) this.quantityInput.value = quantity;
      const compare = Number(variant.compare_at_price);
      const roundedTier = count => Math.round(Math.round(compare * (count === 2 ? .73 : .69)) * count / 1000) * 1000;
      const tierTotal = count => count === 1 ? variant.price : count === 2 ? roundedTier(2) : Math.round(roundedTier(3) / 3 * count);
      this.querySelectorAll('.oa-offers__tiers input').forEach(input => {
        const count = Number(input.value);
        const price = tierTotal(count) / count;
        input.disabled = !variant.available || (count > 1 && (!compare || price > variant.price));
        this.querySelector(`[data-tier-price="${count}"]`).textContent = this.money.format(tierTotal(count) / 100);
      });
      const selected = this.querySelector('.oa-offers__tiers input:checked');
      if (selected?.disabled) {this.querySelector('.oa-offers__tiers input[value="1"]').checked = true; if (this.quantityInput) this.quantityInput.value = 1; return this.update(false);}
      const soapTotal = [...this.querySelectorAll('.oa-offers__soaps input:checked')].reduce((sum, input) => sum + Number(input.dataset.price), 0);
      const mainTotal = this.dataset.bundle === 'true' ? variant.price * quantity : tierTotal(quantity);
      this.querySelector('[data-offer-total]').textContent = this.money.format((mainTotal + soapTotal) / 100);
      const buyNow = this.form?.querySelector('[data-oa-buy-now]');
      if (buyNow) {
        const offerBuyNow = this.form.querySelector('[data-oa-offer-buy-now]');
        const useOfferBuyNow = this.dataset.preview !== 'true' && soapTotal > 0;
        buyNow.hidden = useOfferBuyNow;
        buyNow.style.display = useOfferBuyNow ? 'none' : '';
        if (offerBuyNow) {offerBuyNow.hidden = !useOfferBuyNow;offerBuyNow.style.display = useOfferBuyNow ? '' : 'none';}
        const blocked = this.dataset.preview === 'true' && (quantity > 1 || soapTotal > 0);
        buyNow.inert = blocked;
        buyNow.style.opacity = blocked ? '.45' : '';
        buyNow.setAttribute('aria-disabled', String(blocked));
      }
      this.querySelector('.oa-offers__status').textContent = '';
    }
  });
}
